import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import Panel from "../TextPanelWidget/TextPanelWidgetClass";

Scrivito.provideEditingConfig("CollapseWidget", {
  title: "Collapse",
  attributes: localizeAttrList(["panels"], "CollapseWidget"),
  properties: ["panels"],
  initialContent: {
    panels: [new Panel(), new Panel()],
  },
});
